import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgEverEvolvingIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={0.3}
      d="M23.897 23.423a.603.603 0 1 0 0-1.206.603.603 0 0 0 0 1.206Zm-2.411 0a.603.603 0 1 0 0-1.206.603.603 0 0 0 0 1.206Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.3}
      d="M26.108 19.898V9.152a.603.603 0 0 0-1.206 0v10.652h-4.374c-.81 0-1.567.398-2.027 1.064a1.26 1.26 0 0 1-1.035.544H14.25c-.413 0-.8-.203-1.036-.543a2.462 2.462 0 0 0-2.027-1.065H6.814V9.152c0-.554.45-1.005 1.005-1.005h10.877a.603.603 0 0 0 0-1.206H7.819c-1.22 0-2.211.992-2.211 2.211v10.746A2.207 2.207 0 0 0 4 22.015a3.823 3.823 0 0 0 3.819 3.819h.804a.603.603 0 0 0 0-1.206h-.804a2.616 2.616 0 0 1-2.613-2.613c0-.554.45-1.005 1.005-1.005h4.976c.413 0 .8.203 1.035.544a2.466 2.466 0 0 0 2.028 1.064h3.216c.81 0 1.567-.398 2.027-1.065.235-.34.622-.543 1.035-.543h4.977c.554 0 1.005.45 1.005 1.005a2.616 2.616 0 0 1-2.613 2.613H11.034a.603.603 0 0 0 0 1.206h12.863a3.823 3.823 0 0 0 3.819-3.82 2.207 2.207 0 0 0-1.608-2.116Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.3}
      d="m21.255 8.622-1.506 5.166a1.794 1.794 0 0 0-.906.316l-2.861-2.045c.045-.158.077-.322.077-.495a1.81 1.81 0 0 0-3.618 0c0 .338.1.65.261.922l-1.85 2.21a1.79 1.79 0 0 0-.621-.117c-.997 0-1.81.811-1.81 1.809 0 .997.813 1.809 1.81 1.809s1.809-.812 1.809-1.81c0-.337-.1-.65-.261-.92l1.85-2.21c.195.071.402.116.621.116.385 0 .741-.123 1.035-.329l2.861 2.045a1.78 1.78 0 0 0-.077.495c0 .997.812 1.809 1.809 1.809a1.806 1.806 0 0 0 1.035-3.288l1.505-5.166a1.806 1.806 0 0 0 1.68-1.796 1.81 1.81 0 0 0-3.618 0c0 .612.308 1.152.775 1.48ZM10.23 16.991a.604.604 0 0 1 0-1.206.604.604 0 0 1 0 1.206Zm4.02-4.824a.604.604 0 1 1 .001-1.207.604.604 0 0 1-.002 1.207Zm5.627 4.02a.604.604 0 0 1 0-1.206.604.604 0 0 1 0 1.206ZM22.29 6.54a.604.604 0 0 1 0 1.206.604.604 0 0 1 0-1.206Z"
    />
  </svg>
);
export default SvgEverEvolvingIcon;
